import { Card, Skeleton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  card: {
    borderRadius: 12,
    background: '#393939',
    color: '#fff',
    padding: '2rem',
    maxWidth: '44em',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.1rem',
    marginTop: '6.5rem',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },

  info: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  previewBox: {
    // border: `3px solid ${theme.palette.primary.main}`,
    borderRadius: 12,
    overflow: 'hidden',
    position: 'relative',
    background: '#ffffff10',
    minHeight: 180,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(2),
    '& > span': {
      borderRadius: 12,
    },
  },
}));

const SongCardSkeleton = () => {
  const { classes } = useStyles();

  return (
    <Card className={classes.card} data-testid="songcard-skeleton">
      <div className={classes.header}>
        <div className={classes.info}>
          <Skeleton variant="circular" width={40} height={40} />
          <div>
            <Skeleton width="15em" height={30} animation="wave" />
            <Skeleton width="10em" height={20} animation="wave" />
            <Skeleton width="8em" height={18} animation="wave" />
          </div>
        </div>
      </div>
      {/* <Skeleton variant="text" width="60%" height={32} /> */}
      <Skeleton
        variant="rectangular"
        height={180}
        className={classes.previewBox}
        animation="wave"
      />
      <div className={classes.actions}>
        <Skeleton variant="rectangular" width="100%" height={80} />
        <Skeleton variant="rectangular" width="100%" height={80} />
        <Skeleton variant="rectangular" width="100%" height={80} />
        <Skeleton variant="rectangular" width="100%" height={80} />
      </div>
    </Card>
  );
};

export default SongCardSkeleton;
